import _ from 'lodash-es';
import Utils from '~/scripts/services/utils';
import kformUtils from "../../utils/kform-utils";

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	const updateComponent = () => {
		$scope.maskOptions = {
			padFractionalZeros: $scope.component.requireDecimal,
			scale:              $scope.component.decimalLimit,
		};

		const affixes = Utils.getCurrencyAffixes({
			decimalSeparator: $scope.component.decimalSeparator,
			decimalLimit:     $scope.component.decimalLimit,
			currency:         $scope.component.currency,
			lang:             $scope.options?.language ?? 'fr',
		});

		$scope.component.prefix = affixes.prefix;
		$scope.component.suffix = affixes.suffix;
	};

	$scope.$watch('component', (/** @type {any} */ newComponent, /** @type {any} */ oldComponent) => {
		if (!_.isEqual(newComponent, oldComponent)) {
			updateComponent();
		}
	}, true);

	updateComponent();

	if ($scope.options?.building) {
		return;
	}

	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
};
